import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../../assets/css/anexosJuridica.css";

const EvidenciaJuridica = () => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let { id } = useParams();

  // API donde se enviarán los archivos
  const API_URL =
    "https://contratosback-dev.azurewebsites.net/api/v1/AdjuntaArchivos/" + id;

  // Manejar selección de archivos
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Tomar todos los archivos seleccionados
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]); // Agregar nuevos archivos a la lista existente
  };

  // Eliminar un archivo de la lista
  const handleRemoveFile = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  // Enviar archivos al API
  const handleSaveFiles = async () => {
    if (files.length === 0) {
      alert("Por favor, selecciona al menos un archivo.");
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("archivos", file);
    });

    try {
      await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Archivos enviados con éxito");
      setFiles([]); // Limpiar la lista de archivos después del envío
    } catch (error) {
      alert("Hubo un error al enviar los archivos.");
      console.error("Error al enviar los archivos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const postData = (e) => {
    e.preventDefault();
    window.location.href = "/SoliictudesJuridica";
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="shadow-lg" style={{ width: "30rem" }}>
        <CardHeader className="bg-secondary text-white text-center">
          <h4>Anexar Documentos</h4>
        </CardHeader>
        <CardBody>
          {/* Área de arrastre y selección de archivos */}
          <FormGroup>
            <div
              className="drag-drop-area"
              onClick={() => document.getElementById("documentos").click()} // Simula el clic en el input al hacer clic en el área
            >
              <Label htmlFor="documentos" className="d-block">
                Arrastre o haga clic aquí para anexar los documentos
              </Label>
              <Input
                type="file"
                id="documentos"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }} // Escondemos el input real
              />
            </div>
          </FormGroup>

          {/* Lista de documentos seleccionados */}
          {files.length > 0 && (
            <div>
              <h5>Documentos seleccionados:</h5>
              <ListGroup>
                {files.map((file, index) => (
                  <ListGroupItem
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    {file.name} ({(file.size / 1024).toFixed(2)} KB)
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => handleRemoveFile(index)}
                    >
                      Eliminar
                    </Button>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          )}

          {/* Botón para enviar archivos */}
          <Button
            color="primary"
            className="mt-3"
            onClick={handleSaveFiles}
            disabled={isLoading || files.length === 0}
          >
            {isLoading ? "Enviando..." : "Guardar Documentos"}
          </Button>
          <hr />
          <Button type="submit" color="danger" onClick={postData}>
            Finalizar
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
};

export default EvidenciaJuridica;
